// base environment shared by all apps
// each app specifies its own environment.base.ts that is based off this file

// AltoAzureTablesUrl, EmbedAzureTablesUrl:
//  values are also stored in Web.config and StorageProvider.cs so update there also if changing here.

import { RawClientConfiguration } from "./adapt-client-configuration";

export const clientConfiguration: Partial<RawClientConfiguration> = {
    AdaptEnvironmentName: "Local",
    AltoApiBaseUri: "http://localhost:4300",
    AltoAzureTablesUrl: "https://adaptdev2.table.core.windows.net/",
    AltoBaseUri: "http://localhost:4305",
    AnalyticsProductId: "",
    ApiBaseUri: "/api",
    BoxClientId: "l4ljnh88sav6vg083t1nx6seu1vdpwnr",
    DeepDiveDomain: "https://adaptdeepdivestaging.z26.web.core.windows.net",
    DropboxAppKey: "kqq9nh24c7i0xp1",
    EmbedApiBaseUri: "/api",
    EmbedAzureTablesUrl: "https://adaptdev2.table.core.windows.net",
    EmbedBaseUri: "http://localhost:4301",
    FroalaKey: "7MD3aG3B2C5C3E2D3E2yQNDMIJd1IQNSEa2EUAf1XVFQa1EaD4D3B2I2A18A15A6C9D4D3==",
    GoogleApiKey: "AIzaSyDkD9k7-4i56CZfwZRUSY0chEYPURr5Kvw",
    GoogleClientId: "799098505879-p5uciuk6kges86pnnhil2rg84d31ee8e.apps.googleusercontent.com",
    IntercomAppId: "q32mupku",
    MicrosoftClientId: "4bdd55c9-a959-42c8-b866-174d1b46dcf3",
    OneDriveClientId: "8f51d602-b047-427a-bcdc-f802ff020035",
    SentryTraceLevelName: "Error",
    ServiceApiBaseUri: "http://localhost:4303",
    StripePublicKey: "pk_test_1FhAZMakNbB63zYwUjAgFfiv",
    ToasterTraceLevelName: "Warning",
    TraceLevelName: "Debug",
    DxLicenseKey: "LCPv1S+r1pNSEeL:B(iRyZNeH:_+;pjt67%<B9bVB!_:z9%S%:LXz>yd+V7f1,bdK7_4o:%!:Spm!(J-_ei,RSN)[,_r[(j,e(+!!,+!3Z+VteQ,YcnR%(RRpI<mQIiVY(%@RZj<[ZQVN!RSZ%_@zZHdt!bd3:<fB%j,d27DL%j,d(eS%3Jei97cmkp-@6_y@6iR)SQt!%%r<27yG9++$aj!!6_!GpL);6b<B>%X<2p@@!Q462b-v2%d)I<-@aQd@pg@@!Q4@2_@F!Qd:Ip!@I<4)aKz<I_y6Ip!@Ii-6>K9<6<4:>Q8vIbR)9jz;!jL;9jyFI7yFI7yFI9ll",
    TrustedVimeoDomain: "http://player.vimeo.com/video/*",
};
